import * as React from 'react';
import { RadialBar, RadialBarChart, Tooltip } from 'recharts';
import TooltipContent from './TooltipContent';

interface Format {
    name: string;
    value: number;
    fill: string;
}

interface RadialProps {
    data: Format[];
    tooltipEnabled: boolean;
    negative: boolean;
    message?: string;
}

function getRadialGeometry(neg: boolean) {
    if (neg) {
        return {
            startAngle: -270,
            endAngle: 90
        };
    } else {
        return {
            startAngle: 90,
            endAngle: -270
        };
    }
}

class Radial extends React.Component<RadialProps> {
    render() {
        const { data, negative, tooltipEnabled, message = '' } = this.props;

        const margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };

        const { startAngle, endAngle } = getRadialGeometry(negative);

        return (
            <RadialBarChart
                width={80}
                height={80}
                cx={40}
                cy={40}
                innerRadius={30}
                outerRadius={170}
                barSize={12}
                data={data}
                startAngle={startAngle}
                endAngle={endAngle}
                margin={margin}
            >
                <RadialBar
                    dataKey="value"
                    background={true}
                />
                { tooltipEnabled &&
                    <Tooltip
                        content={<TooltipContent message={message} />}
                        wrapperStyle={{ zIndex: 1000}}
                        coordinate={{ x: 300, y: 140 }}
                    />
                }
            </RadialBarChart>
        );
    }
}

export default Radial;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/Radial.tsx